import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kindSelect", "commercialFields", "residentialFields"]

  connect() {
    // wait for selectize to initialize
    if (this.hasKindSelectTarget) {
      setTimeout(() => this.update())
    }
  }

  update() {
    this.commercialFieldsTarget.toggleAttribute("disabled", this.kind != "commercial")
    this.residentialFieldsTarget.toggleAttribute("disabled", this.kind != "residential")
  }

  get kind() {
    return this.kindSelectTarget.value
  }
}
